// extracted by mini-css-extract-plugin
export default {"FileUploadInput":"FileInput_FileUploadInput__zcswY","UploadInput":"FileInput_UploadInput__o70th","Content":"FileInput_Content__wk28H","Horizonal":"FileInput_Horizonal__8kGy3"};